import { z } from 'zod'

// Note: mirrors the BE `DisplayColumnDashboard` / `DisplayField` / `DisplayFieldType` constants
// (chitowntrainer-sails api/constants/DisplayColumn) - the values are the API keys.
export const DisplayColumnDashboardEnum = z.enum([
  'Announcements',
  'Checklists',
  'Contacts',
  'Maintenance',
  'MarketShop',
  'Packages',
  'Parking',
  'Reservations',
  'Rewards',
  'Survey',
  'Visitors',
])

export type DisplayColumnDashboard = z.infer<typeof DisplayColumnDashboardEnum>

export const DisplayColumnKeyEnum = z.enum([
  'approvedBy',
  'assignee',
  'checkedIn',
  'checkedOut',
  'createdBy',
  'recipient',
  'reservedFor',
  'resident',
])

export type DisplayColumnKey = z.infer<typeof DisplayColumnKeyEnum>

export const DisplayFieldTypeEnum = z.enum(['mixed', 'resident', 'staff'])

export type DisplayFieldType = z.infer<typeof DisplayFieldTypeEnum>

// Note: which person details a column shows. `firstName`/`lastName` are stored separately on the
// BE but are always both on - the name is the one detail a person cell can't hide.
export interface DisplayColumnFields {
  apartment: boolean
  avatar: boolean
  buildingNumber: boolean
  email: boolean
  firstName: boolean
  lastName: boolean
  phone: boolean
  role: boolean
  street: boolean
}

export type DisplayColumnField = keyof DisplayColumnFields

export interface DisplayColumnSettings extends DisplayColumnFields {
  buildingId: number
  column: DisplayColumnKey
  dashboard: DisplayColumnDashboard
  fieldType: DisplayFieldType
}

// Note: a row's `<column>Display` object (BE `DisplayColumnService.appendDisplayObjects`) - the
// person's values for ONLY the fields the column's settings enable; a disabled or empty field is
// absent. The BE is the source of truth for what a person cell shows.
export type PersonDisplay = Partial<Record<DisplayColumnField, string | number | null>>
